import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoVisa16 = t0 => {
  const $ = _c(5);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g><path d="M7.92216 5.09127L6.85323 10.0887H5.56027L6.62932 5.09127H7.92216ZM13.3615 8.3182L14.042 6.44155L14.4336 8.3182H13.3615ZM14.8045 10.0887H16L14.9556 5.09127H13.8528C13.6043 5.09127 13.3948 5.23537 13.302 5.45759L11.3621 10.0887H12.7199L12.9894 9.3424H14.6479L14.8045 10.0887ZM11.4294 8.45724C11.435 7.13832 9.60616 7.06526 9.61841 6.47594C9.62235 6.29689 9.7932 6.10614 10.1666 6.05736C10.3517 6.03353 10.8626 6.0142 11.4417 6.28104L11.6682 5.22087C11.3571 5.10835 10.9569 5 10.4588 5C9.18072 5 8.28162 5.6789 8.27443 6.65185C8.26622 7.37133 8.91669 7.77249 9.40575 8.01213C9.90998 8.25706 10.0789 8.41408 10.0764 8.63293C10.073 8.96822 9.67439 9.1167 9.30324 9.12232C8.65288 9.13244 8.27589 8.94653 7.97544 8.80647L7.74075 9.90205C8.04333 10.0405 8.60084 10.161 9.17813 10.1672C10.537 10.1672 11.4254 9.49628 11.4294 8.45724ZM6.07473 5.09127L3.97991 10.0887H2.61345L1.5825 6.10041C1.52 5.85515 1.46549 5.765 1.27542 5.66137C0.964517 5.49254 0.451292 5.33462 0 5.23638L0.0305735 5.09127H2.23049C2.51071 5.09127 2.76283 5.27774 2.82701 5.60056L3.37159 8.49265L4.71648 5.09127H6.07473Z" fill="#1434CB" /></g>;
    t2 = <defs />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ariaLabel || $[3] !== className) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}</svg>;
    $[2] = ariaLabel;
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default IcoVisa16;